export enum InputFileRejectedReason {
    badFile,
    limitReached,
    sizeReached
}
